module.exports = __webpack_public_path__ + "static/img/third1_3_active.40aa102c.png";